// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20aQJ","top":"styles_top__2ooeG","left":"styles_left__2OJqA","description":"styles_description__1WQhU"};